import { useEffect } from "react";

function getDeviceClass(width) {
  if (width < 480) return "fpb-device-xs";
  if (width < 768) return "fpb-device-sm";
  if (width < 1024) return "fpb-device-md";
  if (width < 1280) return "fpb-device-lg";
  return "fpb-device-xl";
}

export default function ResponsiveLayoutEnhancer() {
  useEffect(() => {
    const deviceClasses = ["fpb-device-xs", "fpb-device-sm", "fpb-device-md", "fpb-device-lg", "fpb-device-xl"];

    const applyDeviceClass = () => {
      document.documentElement.classList.remove(...deviceClasses);
      document.documentElement.classList.add(getDeviceClass(window.innerWidth));
      document.documentElement.style.setProperty("--fpb-vh", `${window.innerHeight * 0.01}px`);
    };

    const hardenLinks = () => {
      document.querySelectorAll('a[target="_blank"]').forEach((link) => {
        const rel = new Set((link.getAttribute("rel") || "").split(" ").filter(Boolean));
        rel.add("noopener");
        rel.add("noreferrer");
        link.setAttribute("rel", Array.from(rel).join(" "));
      });
    };

    const improveTables = () => {
      document.querySelectorAll("table").forEach((table) => {
        const parent = table.parentElement;
        if (!parent || parent.classList.contains("fpb-scroll-x")) return;
        const wrapper = document.createElement("div");
        wrapper.className = "fpb-scroll-x";
        parent.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    };

    const improveIconButtons = () => {
      document.querySelectorAll("button").forEach((button, index) => {
        const text = button.textContent?.trim();
        const hasLabel = button.getAttribute("aria-label") || button.getAttribute("title");
        if (!text && !hasLabel) {
          button.setAttribute("aria-label", `Action button ${index + 1}`);
        }
      });
    };

    const markLoaded = () => document.body.classList.add("fpb-ui-ready");

    applyDeviceClass();
    hardenLinks();
    improveTables();
    improveIconButtons();
    markLoaded();

    window.addEventListener("resize", applyDeviceClass, { passive: true });
    window.addEventListener("orientationchange", applyDeviceClass, { passive: true });

    const observer = new MutationObserver(() => {
      hardenLinks();
      improveIconButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("resize", applyDeviceClass);
      window.removeEventListener("orientationchange", applyDeviceClass);
      observer.disconnect();
    };
  }, []);

  return null;
}
